import { IProductionGroupWell } from '../../interfaces/iproduction-group-well';
import { ProductionGroup } from '../production-group';
import { Well } from '../well';

export class ProductionGroupWellBase {
  ProductionGroupWellId: number;
  ProductionGroupId: number;
  WellId: number;
  SortOrder: number;
  Created: Date | null;
  CreatedBy: string | null;
  Updated: Date | null;
  UpdatedBy: string | null;

  ProductionGroup?: ProductionGroup;
  Well?: Well;

  constructor(item?: IProductionGroupWell) {
    if (item) {

      this.ProductionGroupWellId = item.ProductionGroupWellId;
      this.ProductionGroupId = item.ProductionGroupId;
      this.WellId = item.WellId;
      this.SortOrder = item.SortOrder;
      this.Created = item.Created ? new Date(item.Created) : null;
      this.CreatedBy = item.CreatedBy;
      this.Updated = item.Updated ? new Date(item.Updated) : null;
      this.UpdatedBy = item.UpdatedBy;

      this.ProductionGroup = new ProductionGroup(item.ProductionGroup);
      this.Well = new Well(item.Well);
    }
  }
}